export default "__VITE_ASSET__C90UwQjl__"